module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av543-6213c64db8bf84ea5bd06a471e474d1c.jpg";